import { createReducer, on } from "@ngrx/store";
import { loadUserProfile, loadUserProfileFailed, loadUserProfileSuccess, updateUserProfile } from "../actions/profile.actions";
import { profileInitialState } from "../initial-states/profile.state";
import { UserInformation } from "src/app/models/profile.model";

export const ProfileReducer = createReducer(profileInitialState,
	on(loadUserProfile,
		(state) => ({
			...state, // Copy the existing state
			loading: true
		}),
	),

	on(loadUserProfileSuccess,
		(state, { profile }) => ({ ...state, loading: false, loadedOnce: true, value: updateProfileDefaultLetters(profile) }),
	),

	on(loadUserProfileFailed,
		(state, { error }) => ({ ...state, loading: false, loadedOnce: true, error: error, value: undefined }),
	),

	on(updateUserProfile,
		(state, { updatedProfile }) => ({ ...state, loading: false, loadedOnce: true, value: updateProfileDefaultLetters(updatedProfile) }),
	),
)

function updateProfileDefaultLetters(profile: UserInformation) {

	if (profile.firstName) {
		profile.initialLetters = (profile.lastName ? (profile.firstName[0] + profile.lastName[0]) : (profile.firstName[0] + (profile.firstName[1] ? profile.firstName[1] : "")))?.toUpperCase();
	}
	else {
		profile.initialLetters = profile.email.substring(0, 2);
	}

	return profile;
}
